import { IServiceHistoriesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useServiceHistories = (vin: string): IServiceHistoriesHook => {
  const { serviceHistoryStore } = useStore();
  const {
    serviceHistories,
    totalCount,
    currentPage,
    skipCount,
    maxResultCount,
    loading,
    handlePageChange,
  } = serviceHistoryStore;

  useEffect(() => {
    return () => {
      serviceHistoryStore.resetServiceHistories();
    };
  }, [serviceHistoryStore]);

  useEffect(() => {
    serviceHistoryStore.getAll({
      vin,
      maxResultCount,
      skipCount,
    });
  }, [serviceHistoryStore, vin, maxResultCount, skipCount]);

  return {
    loading,
    dataSource: Array.from(serviceHistories.values()),
    totalCount,
    skipCount,
    currentPage,
    maxResultCount,
    handlePageChange,
  };
};
